// @ utilities
const { APIGet } = require('utilities/APIRequestHelper');

// @ constants
const actionTypes = require('constants/actionTypes');

const reset = () => ({
    type: actionTypes.HIRE_CARD_NAME_SELECTOR_RESET,
});

const setSelectedIndex = id => ({
    type: actionTypes.HIRE_CARD_NAME_SELECTOR_SET_ID,
    payload: {
        id
    }
});

const hireCardNamesRequest = () => ({
    type: actionTypes.HIRE_CARD_NAME_SELECTOR_REQUEST,
});

const hireCardNamesSuccess = names => ({
    type: actionTypes.HIRE_CARD_NAME_SELECTOR_SUCCESS,
    payload: {
        names
    }
});

const hireCardNamesFailure = error => ({
    type: actionTypes.HIRE_CARD_NAME_SELECTOR_FAILURE,
    payload: {
        error
    }
});

const getHireCardNames = () => (dispatch, getState) => {
    if (!getState().hireCardNameSelector.get('isFetching')) {
        dispatch(hireCardNamesRequest());

        return APIGet({
            dispatch,
            endpoint: 'requestCardNames'
        })
            .then(response => {
                dispatch(hireCardNamesSuccess(response));
            })
            .catch(response => {
                if (!!response.error) {
                    dispatch(hireCardNamesFailure(response.error));
                } else {
                    throw response;
                }
            });
    }
};

module.exports = {
    getHireCardNames,
    reset,
    setSelectedIndex,
};
